// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"2fa77688","703":"b71bacf6","787":"aadca95f"}[chunkId] + ".chunk.js";
};